import React from "react";

export const Loader = () => {
  return <span class="loader"></span>;
};
